export default __webpack_public_path__ + "static/media/type-gray.bb86be8f.svg";